import { EMPTY_SEARCH_MODE_ENTITY, SearchModeEntity } from "domain/entity/ChargeDataEnquiry/SearchModeEntity";
import { ChargeDetailConstant } from "presentation/constant/ChargeDetailMaintenance/ChargeDetailConstant";
import { useChargeHeaderMaintenanceVM } from "presentation/hook/ChargeHeaderMaintenance/useChargeHeaderMaintenanceVM";
import { useMessageBarVM } from "presentation/hook/useMessageBar";
import { useANAInfoTracked } from "presentation/store/ANAInfo";
import { useChargeHeaderMaintenanceTracked } from "presentation/store/ChargeHeaderMaintenance/ChargeHeaderMaintenanceProvider";
import { useEffect, useMemo, useState } from "react";
import { HPHButton, IconButton, Loader } from "veronica-ui-component/dist/component/core";
import { SidebarActionBar, SidebarActionCross, SidebarTitle, Sidebarheader } from "veronica-ui-component/dist/component/core/styled/uiFramework.styled";
import { ChargeHeaderSearchCriteriaEditVoyagePanel } from "./ChargeHeaderSearchCriteriaEditPanel/ChargeHeaderSearchCriteriaEditVoyagePanel";

export const ChargeHeaderSearchCriteriaPanel = () => {
    const [chargeHeaderSearchState] = useChargeHeaderMaintenanceTracked();
    const messageBarVM = useMessageBarVM();
    const chargeHeaderSearchVM = useChargeHeaderMaintenanceVM();
    const searchCriteria = chargeHeaderSearchState.searchCriteria;
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const searchModeEntity: SearchModeEntity = {
        ...EMPTY_SEARCH_MODE_ENTITY,
    };
    const CHARGEDETAIL_CONSTANT = ChargeDetailConstant.Charge;
    const [anaInfoState] = useANAInfoTracked();

    const memoChargeHeaderSearchCriteriaEditVoyagePanel = useMemo(() => {
        return <ChargeHeaderSearchCriteriaEditVoyagePanel />
    }, []);

    const handleClearClicked = () => {
        chargeHeaderSearchVM.onRemoveAllSearchCriteria(anaInfoState.userName);
    }

    useEffect(() => {
        let timer: any = null;
        const cb = () => {
            const comField: any = document.querySelector('.im-charge-data-search-criteria-content input[name="co"]');
            if (comField) {
                comField.focus();
                timer && clearInterval(timer);
            }
        };

        timer = setInterval(cb, 0);
    }, []);

    const handleSearch = (e: any) => {
        if (chargeHeaderSearchVM.validateSearchCriteria(searchCriteria)) {
            messageBarVM.showError("Fill in at least one of the search criteria.");
            return;
        }
        setIsLoading(true);
        chargeHeaderSearchVM.setIsSearchLoading(true);

        chargeHeaderSearchVM.onSearch(searchCriteria, searchModeEntity).then(data => {
            if (data && data["validateSearchCriteria"]) {
                messageBarVM.showError(data["validateSearchCriteria"]?.toString());
            } else {
                chargeHeaderSearchVM.onSwithTableStructure();
                localStorage.setItem("ChargeHeaderSearchCriteria", JSON.stringify(searchCriteria));
            }
            setIsLoading(false);
            chargeHeaderSearchVM.setIsSearchLoading(false);
        }).catch((error) => {
            messageBarVM.showError(error.message);
            setIsLoading(false);
            chargeHeaderSearchVM.setIsSearchLoading(false);
        });

    }

    const closeButtonClicked = () => {
        chargeHeaderSearchVM.onSearchClick();
    }

    return <div className='side-form-content-left-wrapper' style={{ padding: "20px 20px 20px 0px", display: 'flex', height: 'calc(100vh - 1vh - 62px)' }}>
        {isLoading && <Loader Indicator="Spinner" size="Medium" />}
        <div className={'flex-row'}>
            <div className={'flex-row-item flex-row-item-full-width'}>
                <Sidebarheader>
                    <SidebarTitle>{CHARGEDETAIL_CONSTANT.SEARCH_CRITERIA}</SidebarTitle>

                    <SidebarActionCross>
                        <IconButton
                            fileName="Icon-cross" size="medium" toolTipText='Close' toolTipArrow={false} onClick={closeButtonClicked} />
                    </SidebarActionCross>
                </Sidebarheader>
            </div>
        </div>

        <>
            <div className={'add-edit-form'} style={{ minHeight: '0', flex: '1', overflowY: 'auto' }}>
                <div className="flex-row-auto">
                    <div className={'flex-row-item'}>

                        {/* Stack Form Start */}
                        {memoChargeHeaderSearchCriteriaEditVoyagePanel}
                    </div>
                </div>
            </div>
            <SidebarActionBar>
                <HPHButton label={'Reset'} size={'Small'} theme={'Secondary'} onClick={handleClearClicked} />
                <HPHButton label={'Search'} size={'Small'} theme={'Primary'} onClick={handleSearch} />
            </SidebarActionBar>
        </>
    </div>
};
